const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    reload: 'cart.reload',
    freeGift: 'cart.free_gift',
    disableCheckout: 'cart.disable_checkout'
  },
  product: {
    updateVariant: 'product.update_variant',
    openQuickAdd: 'product.open_quick_add',
    openColourwayDrawer: 'product.open_colourway_drawer',
    openDropSignup: 'product.open_drop_signup',
    selectedVariant: 'product.selected_variant'
  },
  collection: {
    productsLoaded: 'collection.products_loaded'
  },
  notice: {
    global: 'notice.global'
  },
  account: {
    login: 'account.login',
    register: 'account.register'
  },
  recommendations: {
    affinities: 'recommendations.affinities',
    campaigns: 'recommendations.campaigns',
    products: 'recommendations.products'
  },
  gwp: {
    maxGifts: 'gwp.max_gifts'
  }
}

class GlobalEmitter {
  constructor () {
    this.listeners = new Map()
  }

  emit (name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })
    document.dispatchEvent(event)
  }

  on (name, callback) {
    const wrappedCallback = (e) => {
      callback(e.detail)
    }

    if (!this.listeners.has(name)) {
      this.listeners.set(name, new Map())
    }

    this.listeners.get(name).set(callback, wrappedCallback)
    document.addEventListener(name, wrappedCallback)
  }

  off (name, callback) {
    const wrappedCallback = this.listeners.get(name)?.get(callback)
    if (!wrappedCallback) return

    document.removeEventListener(name, wrappedCallback)
    this.listeners.get(name).delete(callback)
  }
}

const globalEmitter = new GlobalEmitter()

export {
  emitterProps,
  globalEmitter
}
